import React, { useEffect } from 'react';
import { Rocket, X } from 'lucide-react';

interface GenerationNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GenerationNotificationModal: React.FC<GenerationNotificationModalProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;

  // Auto-close after 7 minutes (420000 ms)
  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(() => {
      try { onClose(); } catch {}
    }, 420000);
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <div className="fixed inset-0 bg-brand-black/50 backdrop-blur-sm flex items-center justify-center z-[100000] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
        
        <div className="flex flex-col items-center text-center">
          <div className="bg-blue-100 p-3 rounded-full mb-4">
            <Rocket className="w-8 h-8 text-blue-600" />
          </div>
          
          <h2 className="text-xl font-semibold mb-2">¡Genial!</h2>
          
          <p className="text-gray-700 mb-4">
            La IA comenzará a generar contenido para tu marca basado en el plan de marketing generado.
          </p>
          
          <p className="text-gray-700 mb-6">
            Las primeras publicaciones generadas aparecerán en tu calendario en unos momentos.
          </p>
          
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-normal"
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenerationNotificationModal;
